import type { TOC } from '@ember/component/template-only'
import { FidgetLoadingIndicatorComponent } from '@blakeelearning/fidget/components/fidget/loading-indicator'
import RouteTemplate from 'ember-route-template'

export const ApplicationLoadingPage: TOC<unknown> = <template>
  {{! Application loading substate - we only want to show this for initial app load }}
  <FidgetLoadingIndicatorComponent @show={{true}} @centered={{true}} />
</template>

export default RouteTemplate(ApplicationLoadingPage)
